import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NewsCard from '../components/NewsCard';
import { getNewsDataAsync } from '../utils/newsStorage';
import '../styles/Category.css';

const CategoryPage = () => {
  const { category } = useParams();
  const [filteredNews, setFilteredNews] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      const all = await getNewsDataAsync();
      if (!mounted) return;
      const lower = String(category).toLowerCase();
      const filtered = all.filter(news => {
        if (Array.isArray(news.category)) {
          return news.category.some(c => String(c).toLowerCase() === lower);
        }
        if (typeof news.category === 'string') {
          return news.category.toLowerCase() === lower;
        }
        return false;
      });
      setFilteredNews(filtered);
    };
    load().catch(err => console.warn('Failed to load category news', err));
    return () => { mounted = false; };
  }, [category]);

  return (
    <div className="category-page">
      <div className="category-header">
        <h1>{category} News</h1>
        <p>Latest updates from Jodhpur on {category}</p>
      </div>

      <div className="category-news-grid">
        {filteredNews.length > 0 ? (
          filteredNews.map(news => (
            <NewsCard 
              key={news.id}
              title={news.title}
              excerpt={news.excerpt}
              category={news.category}
              date={news.date}
              image={news.image}
            />
          ))
        ) : (
          <p className="no-news">No news articles found in this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;